module.exports = __webpack_public_path__ + "static/media/logo-grupo.7c363dde.jpg";